export default "__VITE_ASSET__CmjO$N1N__"